"use client";

import { FC, useEffect, useRef } from "react";

export const CookieInformationPage: FC<{ cookieBotId: string | null }> = ({
  cookieBotId,
}) => {
  const cookieBotDivRef = useRef<HTMLDivElement>(null);
  const isInjected = useRef(false);

  useEffect(() => {
    if (cookieBotId && !isInjected.current && cookieBotDivRef.current) {
      const script = document.createElement("script");
      script.id = "CookieDeclaration";
      script.src = `https://consent.cookiebot.com/${cookieBotId}/cd.js`;
      script.async = true;
      cookieBotDivRef.current.appendChild(script);
      isInjected.current = true;
    }
  }, [cookieBotId]);

  return <div ref={cookieBotDivRef}></div>;
};

export default CookieInformationPage;
